import { render } from "./EditLesson.vue?vue&type=template&id=63d90302&scoped=true"
import script from "./EditLesson.vue?vue&type=script&lang=js"
export * from "./EditLesson.vue?vue&type=script&lang=js"

import "./EditLesson.vue?vue&type=style&index=0&id=63d90302&scoped=true&lang=css"
import "./EditLesson.vue?vue&type=style&index=1&id=63d90302&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63d90302"]])

export default __exports__